// ABOUTME: The viewport's width in px, kept current on window resize.
// ABOUTME: The desktop cloud stack's scale reads it, so the stack follows a resized window.
import { useEffect, useState } from 'react';

export function useViewportWidth(): number {
  const [width, setWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return width;
}
